import { __assign } from "tslib";
import fonts from './fonts';
import { ProviderTypes } from './types';
export var fontFamilyToWixEmailsFontsHref = fonts
    .filter(function (_a) {
    var provider = _a.provider;
    return provider === ProviderTypes.google;
})
    .reduce(function (acc, _a) {
    var _b;
    var fontFamily = _a.fontFamily, cdnName = _a.cdnName, normalizedFontFamily = _a.normalizedFontFamily;
    return (__assign(__assign({}, acc), (_b = {}, _b[normalizedFontFamily] = {
        href: "https://static.parastorage.com/unpkg/@wix/wix-emails-fonts@1.1.2/f/".concat(encodeURIComponent(cdnName), ".css"),
        name: fontFamily,
    }, _b)));
}, {});
//# sourceMappingURL=font-family-to-google-href.js.map